import { messages } from './messages';

export const TotalQuantity = {
  messageDescriptor: messages.totalQuantity,
  id: 'quantity',
};
